// const filterItems = document.querySelectorAll('.filter__form-item');

// if (filterItems) {
//   filterItems.forEach(el => {
//     el.addEventListener('click', (e) => {
//       let sublink = e.target.querySelector('.filter__form-item--sub');
//       if (sublink) {
//         sublink.classList.toggle('filter__form-item--sub--active');
//       }

//     });
//   })
// }